import BluetoothDeviceManager from '@/plugins/bluetooth/DeviceManager';

const bluetoothDeviceManager = new BluetoothDeviceManager();

export default {
    install (Vue) {
        Vue.prototype.$bluetoothDeviceManager = bluetoothDeviceManager;
    }
}
